var map = {
	"./admin-dashboard/absent-time.webp": "2053",
	"./admin-dashboard/active-employees.webp": "c875",
	"./admin-dashboard/company.webp": "6bf9",
	"./admin-dashboard/filed-work-tree.webp": "5e04",
	"./admin-dashboard/inactive-employees.webp": "1503",
	"./admin-dashboard/late-tortoise.webp": "3f76",
	"./admin-dashboard/leave-distribution.webp": "e854",
	"./admin-dashboard/leave-timer.webp": "e60e",
	"./admin-dashboard/other-workplace.webp": "183a",
	"./admin-dashboard/present-employee.webp": "4520",
	"./admin-dashboard/team-availability.webp": "a169",
	"./admin-dashboard/team-updates.webp": "1a09",
	"./admin-dashboard/work-from-home.webp": "6937",
	"./asset-management/asset-delete.webp": "c2cf",
	"./benefits/esop/man-with-shares.webp": "7c8b",
	"./billing/demo-booking.webp": "2266a",
	"./billing/discount-offer.webp": "45de",
	"./billing/discount-panel.webp": "4a16",
	"./billing/empty-plan.webp": "fb8f",
	"./billing/help-icon.webp": "74a1",
	"./billing/money-back-guarantee.webp": "2dd3",
	"./billing/offer-icon.webp": "7290",
	"./billing/special-offer.webp": "7f31",
	"./billing/video.webp": "c3a2",
	"./common/add-employees.webp": "f22e",
	"./common/block.webp": "356b",
	"./common/cannyhr-logo.webp": "fa53",
	"./common/delete-bin.webp": "26de",
	"./common/empty-search.webp": "b6f5",
	"./common/exit_form.webp": "6c8b",
	"./common/export-csv-file.webp": "5921",
	"./common/export-xlsx-file.webp": "e8ad",
	"./common/file-preview.webp": "be13",
	"./common/green-left-background.webp": "a2af",
	"./common/green-right-background.webp": "d9eb",
	"./common/hrapp-logo.webp": "7199",
	"./common/human-error-image.webp": "9352",
	"./common/idea-bulb.webp": "b53c",
	"./common/initial-fetch-error-image.webp": "1fc8",
	"./common/no-active-employees.webp": "f7f0",
	"./common/no-records.webp": "106d",
	"./common/notify-email.webp": "d5cd",
	"./common/popover-empty.webp": "16f3",
	"./compliance-management/document-generator/document-generator-empty.webp": "9c13",
	"./compliance-management/document-generator/document-signature-empty.webp": "c034",
	"./compliance-management/signatories/already-signed.webp": "cb3d",
	"./compliance-management/signatories/signature-error.webp": "70c8",
	"./compliance-management/signatories/url-expired.webp": "3ce4",
	"./core-hr/custom-group-no-records.webp": "9a7b",
	"./core-hr/empty-work-schedule.webp": "2892",
	"./dashboard/actions-empty-image.webp": "0ac5",
	"./dashboard/at-work.webp": "4cf9",
	"./dashboard/benefits-empty-image.webp": "6a2e",
	"./dashboard/birthday-cake-img.webp": "629a",
	"./dashboard/birthday-celebration.webp": "0b43",
	"./dashboard/calendar.webp": "f58f",
	"./dashboard/company-update.webp": "afdb",
	"./dashboard/company-updates-empty-image.webp": "de00",
	"./dashboard/expenses-empty-image.webp": "0156",
	"./dashboard/field.webp": "aa69",
	"./dashboard/gps-not-accurate.webp": "e14c",
	"./dashboard/holiday-empty-image.webp": "3c94",
	"./dashboard/holidays.webp": "4c08",
	"./dashboard/late.webp": "0b3e",
	"./dashboard/leave-closure-warning.webp": "52ea",
	"./dashboard/leave-history.webp": "05d0",
	"./dashboard/location-not-found.webp": "4a4c",
	"./dashboard/mild-smiley.webp": "5fd4",
	"./dashboard/office.webp": "c939",
	"./dashboard/on-duty.webp": "2041",
	"./dashboard/payslip-empty-image.webp": "2702",
	"./dashboard/sad-face-avatar.webp": "210c",
	"./dashboard/tax-empty-image.webp": "c57f",
	"./dashboard/timeoff-empty-image.webp": "649b",
	"./dashboard/work-from-home.webp": "91bf",
	"./employee-monitoring/activity-tracker/accpet-invite-error.webp": "d869",
	"./employee-monitoring/activity-tracker/activate-admin-bg.webp": "3cc9",
	"./employee-monitoring/activity-tracker/activate-admin-download-app.webp": "8022",
	"./employee-monitoring/activity-tracker/activate-admin-info.webp": "e533",
	"./employee-monitoring/activity-tracker/activate-employee-bg.webp": "36e0",
	"./employee-monitoring/activity-tracker/activate-employee.webp": "7a1c",
	"./employee-monitoring/activity-tracker/activity-monitor-trial-expired.webp": "5b27",
	"./employee-monitoring/activity-tracker/activity-tracked.webp": "4896",
	"./employee-monitoring/activity-tracker/activity-tracker-error-screen.webp": "d92f",
	"./employee-monitoring/activity-tracker/activity-tracker-logo.webp": "aa3b",
	"./employee-monitoring/activity-tracker/add-more-member-licence.webp": "031a",
	"./employee-monitoring/activity-tracker/admin-activate-btn.webp": "a582",
	"./employee-monitoring/activity-tracker/browser-chrome-logo.webp": "ed72",
	"./employee-monitoring/activity-tracker/browser-firefox-logo.webp": "a12b",
	"./employee-monitoring/activity-tracker/browser-ie-logo.webp": "1988",
	"./employee-monitoring/activity-tracker/browser-msedge-logo.webp": "2cdf",
	"./employee-monitoring/activity-tracker/browser-opera-logo.webp": "46ae",
	"./employee-monitoring/activity-tracker/browser-safari-logo.webp": "44ca",
	"./employee-monitoring/activity-tracker/computer-activities.webp": "fe2a",
	"./employee-monitoring/activity-tracker/download-linux-app-btn.webp": "e145",
	"./employee-monitoring/activity-tracker/download-mac-app-btn.webp": "8d7b",
	"./employee-monitoring/activity-tracker/download-windows-app-btn.webp": "e1b9",
	"./employee-monitoring/activity-tracker/emp-intro-request-access.webp": "b419",
	"./employee-monitoring/activity-tracker/emp-invite-request-access-btn.webp": "1a49",
	"./employee-monitoring/activity-tracker/emp-not-invited-learn-more.webp": "108f",
	"./employee-monitoring/activity-tracker/graph-blue.webp": "85c3",
	"./employee-monitoring/activity-tracker/graph-green.webp": "b284",
	"./employee-monitoring/activity-tracker/graph-pink.webp": "d673",
	"./employee-monitoring/activity-tracker/graph-purple.webp": "fe4e",
	"./employee-monitoring/activity-tracker/intro-screen-help-female.webp": "b520",
	"./employee-monitoring/activity-tracker/invite-import.webp": "6b54",
	"./employee-monitoring/activity-tracker/invite-manual.webp": "8ed3",
	"./employee-monitoring/activity-tracker/invite-members-btn.webp": "75b3",
	"./employee-monitoring/activity-tracker/linked-in-bg.webp": "cf55",
	"./employee-monitoring/activity-tracker/linked-in-info.webp": "3599",
	"./employee-monitoring/activity-tracker/linux-logo.webp": "52fc",
	"./employee-monitoring/activity-tracker/low-activity.webp": "d639",
	"./employee-monitoring/activity-tracker/mac-download.webp": "d39f",
	"./employee-monitoring/activity-tracker/mac-logo.webp": "0623",
	"./employee-monitoring/activity-tracker/member-statistics.webp": "1104",
	"./employee-monitoring/activity-tracker/my-activity.webp": "51ff",
	"./employee-monitoring/activity-tracker/no-activities.webp": "b2cb",
	"./employee-monitoring/activity-tracker/no-activity.webp": "5bac",
	"./employee-monitoring/activity-tracker/no-apps-activity.webp": "023d",
	"./employee-monitoring/activity-tracker/no-insights-activity.webp": "8e1a",
	"./employee-monitoring/activity-tracker/no-records-my-team-actiivity.webp": "b41d",
	"./employee-monitoring/activity-tracker/no-records-team-members.webp": "b4cd",
	"./employee-monitoring/activity-tracker/no-urls-activity.webp": "7354",
	"./employee-monitoring/activity-tracker/org-time-zone.webp": "7aa9",
	"./employee-monitoring/activity-tracker/privacy-mode-alert.webp": "f2bf",
	"./employee-monitoring/activity-tracker/privacy-mode-icon.webp": "63f5",
	"./employee-monitoring/activity-tracker/productive-time.webp": "964c",
	"./employee-monitoring/activity-tracker/productivity.webp": "80e4",
	"./employee-monitoring/activity-tracker/time-and-date.webp": "250a",
	"./employee-monitoring/activity-tracker/url-search-empty.webp": "0ded",
	"./employee-monitoring/activity-tracker/user-active-time.webp": "940c",
	"./employee-monitoring/activity-tracker/user-help.webp": "c51a",
	"./employee-monitoring/activity-tracker/windows-logo.webp": "7958",
	"./employee-monitoring/dashboard/appsurl.webp": "fe4d",
	"./employee-monitoring/dashboard/screen-capture.webp": "fbf6",
	"./employee-monitoring/reports/apps-reports.webp": "ffdf",
	"./employee-monitoring/reports/asset-reports.webp": "e6a1",
	"./employee-monitoring/reports/attendance-reports.webp": "93d0",
	"./employee-monitoring/reports/consolidated-apps-urls.webp": "16a6",
	"./employee-monitoring/reports/custom-range-calendar.webp": "0bf4",
	"./employee-monitoring/reports/daily-calendar.webp": "e385",
	"./employee-monitoring/reports/efficiency-reports.webp": "5bbe",
	"./employee-monitoring/reports/empty-header.webp": "7e98",
	"./employee-monitoring/reports/file-event.webp": "9603",
	"./employee-monitoring/reports/location.webp": "bd4c",
	"./employee-monitoring/reports/low-activity-reports.webp": "aede",
	"./employee-monitoring/reports/monthly-calendar.webp": "4ec7",
	"./employee-monitoring/reports/monthly-summary.webp": "3b12",
	"./employee-monitoring/reports/no-emp-activity-hours.webp": "295d",
	"./employee-monitoring/reports/no-team-activity-hours.webp": "627a",
	"./employee-monitoring/reports/no-team-activity-percentage.webp": "8cba",
	"./employee-monitoring/reports/productive-unproductive-summary.webp": "54eb",
	"./employee-monitoring/reports/productivity-apps.webp": "1ab3",
	"./employee-monitoring/reports/productivity-summary.webp": "2429",
	"./employee-monitoring/reports/productivity-urls.webp": "43ce",
	"./employee-monitoring/reports/time-activity-reports.webp": "da40",
	"./employee-monitoring/reports/unproductive-apps-urls-reports.webp": "6c90",
	"./employee-monitoring/reports/urls-reports.webp": "1496",
	"./employee-monitoring/reports/web-and-file.webp": "a154",
	"./employee-monitoring/reports/web-event.webp": "f678",
	"./employee-monitoring/reports/weekly-calendar.webp": "f904",
	"./employee-monitoring/reports/weekly-summary.webp": "3b88",
	"./employee-monitoring/stealth-mode/consent-based-tracking.webp": "46a8",
	"./employee-monitoring/stealth-mode/invite-admin-members.webp": "7c70",
	"./employee-monitoring/stealth-mode/no-admins.webp": "c857",
	"./employee-monitoring/stealth-mode/no-records-admin-invites.webp": "5a31",
	"./employee-monitoring/stealth-mode/no-records-assets.webp": "937b",
	"./employee-monitoring/stealth-mode/no-team-members.webp": "3de3",
	"./employee-monitoring/stealth-mode/stealth-mode-tracking.webp": "87bd",
	"./employee-monitoring/workforce-analytics/workforce-analytics.webp": "0401",
	"./employees/goals-and-achievement/no-goals-assigned.webp": "5d5c",
	"./employees/goals-and-achievement/no-monthly-team-rating.webp": "0053",
	"./employees/goals-and-achievement/no-yearly-team-rating.webp": "f310",
	"./employees/rewards-and-recognition/motivosity-logo.webp": "255d",
	"./employees/rewards-and-recognition/rewards.webp": "6252",
	"./layout/access-denied.webp": "34ad",
	"./layout/announcement-icon.webp": "0996",
	"./layout/announcement.webp": "3083",
	"./layout/cloud-bg.webp": "1b1d",
	"./layout/demo-booking-left-info.webp": "4f5c",
	"./layout/demo-booking-right-info.webp": "e14f",
	"./layout/demo-booking.webp": "af36",
	"./layout/money-bag.webp": "3471",
	"./layout/networkError.webp": "63b7",
	"./layout/notification-icon.webp": "ea2f",
	"./layout/page-not-found.webp": "c233",
	"./layout/park-green-bg.webp": "4f0c",
	"./payroll/overtime-claim/approval-warning.webp": "c369",
	"./payroll/overtime-claim/overtime-empty-img.webp": "e09c",
	"./payroll/salary-template/new-template.webp": "cefc",
	"./settings/apps.webp": "a9b7",
	"./settings/tax/it-declaration-locked.webp": "5a33",
	"./settings/urls.webp": "1b3d",
	"./shift-scheduling/beach.webp": "f7ed",
	"./shift-scheduling/moon.webp": "8dce",
	"./shift-scheduling/shift-alert.webp": "84b2",
	"./shift-scheduling/shift-empty-image.webp": "58ac",
	"./shift-scheduling/shift-option.webp": "e7a4",
	"./shift-scheduling/shift-scheduling.webp": "102c",
	"./shift-scheduling/shift-validation-success.webp": "af1a",
	"./shift-scheduling/shift-week-off-option.webp": "438d",
	"./shift-scheduling/week-off-option.webp": "68d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c955";